export const ROOT = process.env.PUBLIC_URL;
export const PROFILE = '/profile';
export const FEED = '/feed';
export const CHATS = '/chats';
export const NAUSEARCH = '/nausearch';
export const FOLLOWERS = '/followers';
export const GROUPS = '/groups';
export const EVENTS = '/events';
export const MY_TERRITORY = '/my_territory';
export const MY_TERRITORY_SAVED_SEARCH = '/saved_search';
export const MY_TERRITORY_FILE = '/files';
export const MY_TERRITORY_FEED = '/feeds';
export const MY_TERRITORY_TRANSLATE = '/translate';
export const MY_TERRITORY_REVIEW = '/review';
export const MY_TERRITORY_PUBLICATION = '/publication';
export const MARKETPLACE = '/marketplace';
export const USER = '/user';

export const HELP_URL = '../help/index.html';
